import { type UseQueryOptions, useQuery } from '@tanstack/react-query';
import { listAmazonVendorConnectionsV1IntegrationsAmazonVendorConnectionsGet } from '../../generated';
import type { ListAmazonVendorConnectionsV1IntegrationsAmazonVendorConnectionsGetData } from '../../generated';
import type { ListAmazonVendorConnectionsV1IntegrationsAmazonVendorConnectionsGetError } from '../../generated';
import type { ListAmazonVendorConnectionsV1IntegrationsAmazonVendorConnectionsGetResponse } from '../../generated';

export type ListAmazonVendorConnectionsQueryVariables =
  ListAmazonVendorConnectionsV1IntegrationsAmazonVendorConnectionsGetData['query'];

export type ListAmazonVendorConnectionsQuery =
  ListAmazonVendorConnectionsV1IntegrationsAmazonVendorConnectionsGetResponse;

const buildKey = (variables: ListAmazonVendorConnectionsQueryVariables = {}) =>
  ['ListAmazonVendorConnections', { status: variables?.status ?? null }] as const;

export const useListAmazonVendorConnectionsQuery = <
  TData = ListAmazonVendorConnectionsQuery,
  TError = ListAmazonVendorConnectionsV1IntegrationsAmazonVendorConnectionsGetError,
>(
  variables: ListAmazonVendorConnectionsQueryVariables = {},
  options?: Omit<UseQueryOptions<ListAmazonVendorConnectionsQuery, TError, TData>, 'queryKey' | 'queryFn'>,
) => {
  return useQuery<ListAmazonVendorConnectionsQuery, TError, TData>({
    queryKey: buildKey(variables),
    queryFn: async () => {
      const { data } = await listAmazonVendorConnectionsV1IntegrationsAmazonVendorConnectionsGet({
        query: variables,
        throwOnError: true,
      });
      return data;
    },
    ...options,
  });
};

useListAmazonVendorConnectionsQuery.getKey = (variables: ListAmazonVendorConnectionsQueryVariables = {}) =>
  buildKey(variables);
